var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tab',{class:{ 'icon-loading': _vm.loading },attrs:{"id":_vm.id,"icon":_vm.icon,"name":_vm.name}},[_c('div',{attrs:{"id":"talk-tab-mount"}})])}
var staticRenderFns = []

export { render, staticRenderFns }